import Entity from './entity'
export default class Approval extends Entity<number>{
    startTime: Date
    endTime: Date
}